var React = require('react');

function ArrowButton3 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"next-step-button-circle-path","cx":"35","cy":"35","r":"33","fill":"none","stroke":"#231f20","strokeMiterlimit":"10","strokeWidth":"4","key":0}),React.createElement("path",{"className":"next-step-button-arrow-path","d":"M47.11,40,35,51.32,22.89,40M35,17.3l0,34Z","fill":"none","stroke":"#ffffff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4","key":1})]);
}

ArrowButton3.defaultProps = {"viewBox":"0 0 70 70"};

module.exports = ArrowButton3;

ArrowButton3.default = ArrowButton3;
